import type { SessionProviderProps } from "next-auth/react";
import {
  getSession,
  SessionProvider as NextAuthProvider,
} from "next-auth/react";
import { useEffect } from "react";

function RefetchSessionOnReconnect() {
  useEffect(() => {
    const onOnline = async () => {
      await getSession();
    };
    window.addEventListener("online", onOnline);
    return () => window.removeEventListener("online", onOnline);
  }, []);

  return null;
}

export function UserSessionProvider({
  children,
  ...props
}: SessionProviderProps) {
  return (
    <NextAuthProvider
      {...props}
      refetchOnWindowFocus={false}
      refetchWhenOffline={false}
    >
      <RefetchSessionOnReconnect />
      {children}
    </NextAuthProvider>
  );
}
